import { render, staticRenderFns } from "./DeliveryFeeIndex.vue?vue&type=template&id=b9ea7986"
import script from "./DeliveryFeeIndex.vue?vue&type=script&lang=js"
export * from "./DeliveryFeeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports